import styled from 'styled-components';

import { colors, transition } from 'theme';

export const TabSwitcherContainer = styled.div`
  position: relative;
`;

export const TabSwitcherTabsContainer = styled.div``;

export const TabSwitcherIndicator = styled.div`
  height: 2px;
  background: ${colors.waterBlue};
  transition: ${transition};

  position: absolute;
  bottom: 0;
`;
